import { PapRequestStatus, PapRequestStatusType } from '@app/pcs/models';
import * as R from 'ramda';

type GetPapRequestStatusText = (s: PapRequestStatus) => string;
export const getPapRequestStatusText: GetPapRequestStatusText = R.compose(
  R.concat('paprequest.status.'),
  R.prop('status')
);

type StatusEqual = (statusType: PapRequestStatusType) => (s: PapRequestStatus) => boolean;
export const statusEqual: StatusEqual = R.propEq('status');
